import React from 'react'
import IconWrapper from './IconWrapper'

export const MDNIcon = ({ props }) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="132"
            height="132"
            fill="none"
            viewBox="0 0 132 132"
        >
            <path d="M.5.2H132v131.5H.5V.2zm114.9 60.4c-.1-2-.3-4-.5-5.9-.1-1-.5-1.9-1.1-2.7-.7-.9-1.7-1.6-2.8-2-2.2-.9-4.4-1.8-6.7-2.7-3.2-1.1-6.2-2.4-9.2-4-2-1.1-3.3-3.1-3.6-5.4-.3-2.6-1.8-4.8-4-6.1-2.5-1.3-5.4-1.7-8.1-1-2 .5-4.1.5-6.1-.1l-3-.9-.8-.2-2.4-.7c-4.3-1.3-6.1-2-13.1-.8-7.4 1.7-14.1 5.4-19.4 10.7L17.1 57.3h15.7l-9.6 10.2h16.5l-9.6 10.2h13.3l-4.2 11.1c16.3 16.6 33.6 20 33.6 20 0-4.6 1-22.6 2.3-25.6.5-1.5 1.2-2.9 2.1-4.2 2.3-2.8 5.7-4.4 9.3-4.2 3.6 0 7.1.7 10.5 1.9 2 .8 4.3.7 6.2-.3 1.4-.8 2.8-1.7 4.1-2.6.4-.3 1-.5 1.5-.5 1.5.2 2.9-.6 3.5-2 .4-.9 1-1.8 1.4-2.7 1.2-2.5 1.8-5.3 1.7-8z"></path>
        </svg>
    </IconWrapper>
)
